import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import GradientText from "../components/GradientText";

export default function NoPermission({ ...props }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "100vh",
        // width: "100",
        gap: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {" "}
      <GradientText text="Oops!" />
      <Typography sx={{ fontSize: 14 }}>
        You don't have the correct permissions to
        {props.text ? props.text : ` view  ${props.dbName}`}
      </Typography>
      <Button variant="contained">
        <Link
          to={".."}
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          style={{ textDecoration: "none", color: "white" }}
        >
          Go Back
        </Link>
      </Button>
    </Box>
  );
}
